export function PrivacyContent() {
  return (
    <>
      <h3>1. Introduction</h3>
      <p>
        This Privacy Policy describes how SSP Enterprise (&quot;we,&quot; &quot;us&quot;) collects,
        uses, and protects information in connection with the SSP Enterprise platform at
        enterprise.sspwallet.com.
      </p>

      <h3>2. Information We Do Not Collect</h3>
      <p>
        SSP Enterprise is a self-custodial platform. We do not collect, process, store, or have
        access to your private keys, seed phrases, wallet passwords, or any cryptographic signing
        material. All such data remains exclusively on your devices.
      </p>

      <h3>3. Information We Collect</h3>
      <p>We collect the following categories of information to provide and operate the service:</p>
      <ul>
        <li>
          <strong>Account information</strong> — email address, SSP Identity, display name
        </li>
        <li>
          <strong>Organisation data</strong> — organisation name, description, membership, roles,
          and invitations
        </li>
        <li>
          <strong>Vault data</strong> — vault configuration, public keys, addresses, transaction
          proposals, and policy settings
        </li>
        <li>
          <strong>Usage and security data</strong> — login activity, audit logs, and operational
          metadata necessary for security and compliance
        </li>
        <li>
          <strong>Transaction metadata</strong> — transaction identifiers, amounts, addresses, and
          status
        </li>
      </ul>

      <h3>4. How We Use Your Information</h3>
      <p>
        We use collected information to provide, maintain, and improve the service, authenticate
        users, manage organisations and vaults, enforce policies, maintain audit trails, send
        notifications, and comply with legal obligations.
      </p>

      <h3>5. Data Security</h3>
      <p>
        We implement industry-standard security measures to protect your information, including
        encryption in transit and at rest, access controls, and regular security assessments.
        Sensitive credentials are stored using one-way cryptographic hashing.
      </p>

      <h3>6. Data Retention</h3>
      <p>
        We retain your information for as long as your account is active or as needed to provide the
        service. Certain records may be retained beyond account deletion where required for
        security, compliance, or legal purposes.
      </p>

      <h3>7. Data Sharing</h3>
      <p>
        We do not sell, rent, or trade your personal information. We may disclose information to
        service providers who assist in operating the platform, or where required by law,
        regulation, or valid legal process.
      </p>

      <h3>8. Your Rights</h3>
      <p>
        Depending on your jurisdiction, you may have the right to access, correct, delete, or port
        your personal data, or to object to or restrict certain processing activities. To exercise
        these rights, contact us at{' '}
        <a href="mailto:enterprise@sspwallet.com">enterprise@sspwallet.com</a>.
      </p>

      <h3>9. Cookies and Local Storage</h3>
      <p>
        The platform uses local browser storage for session management and user preferences. We do
        not use third-party tracking cookies or advertising technologies.
      </p>

      <h3>10. Third-Party Services</h3>
      <p>
        The platform may integrate with third-party authentication providers and communication
        services. These services operate under their own privacy policies.
      </p>

      <h3>11. Age Requirement</h3>
      <p>
        SSP Enterprise is not intended for individuals under the age of 18. We do not knowingly
        collect information from minors.
      </p>

      <h3>12. Changes to This Policy</h3>
      <p>
        We may update this Privacy Policy from time to time. Material changes will be communicated
        via the platform or email. Continued use of the service constitutes acceptance of the
        updated policy.
      </p>

      <h3>13. Contact</h3>
      <p>
        For privacy-related enquiries, contact us at{' '}
        <a href="mailto:enterprise@sspwallet.com">enterprise@sspwallet.com</a>.
      </p>
    </>
  );
}
